import {FRBase} from "#Formulas/FormulaCore/FRBase";

export class FRFactory{
    private static FieldDictionary:any={};

    public static GetFRElement(options:any,parent:FRBase){
        if(FRFactory.FieldDictionary[options.T]==null)
            throw new Error('Formula element was not found '+options.T);
        return new FRFactory.FieldDictionary[options.T](options,parent);
    }

    public static AddField(type:string,field:new (options:any,parent:FRBase)=>FRBase){
        FRFactory.FieldDictionary[type]=field;
    }
}